// extracted by mini-css-extract-plugin
export default {"pageContainer":"Page_pageContainer__Yp6sD"};